import { uploadServiceUrl } from '../config/config';

const uploadFile = async (formData, authorizationToken) => {
    try {
      const response = await fetch(`${uploadServiceUrl}/upload`, { 
        method: 'POST',
        body: formData,
        headers: {
          //'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        },
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };
  
export { uploadFile };